import api from "./axiosConfig";

export interface ContactUsReq {
  description: string;
  email: string;
  full_name: string;
  subject: string;
}
export interface ContactUsRes {
  message: string;
}

export const ContactUs = async (data: ContactUsReq) => {
  const response = await api.post<ContactUsRes>(
    "/other/contact-us",
    data
  );
  return response.data;
};
